module.exports = __webpack_public_path__ + "static/media/klemmeno-kalos-bg.304e8df5.jpg";